import { apiClient } from './apiClient';
import {
  CreateBookingRequest,
  CreateBookingResponse,
  BookingResponse,
} from '../types/booking.types';

export const bookingsApi = {
  /**
   * Create a new booking
   */
  async create(data: CreateBookingRequest): Promise<CreateBookingResponse> {
    const response = await apiClient.post<{ success: boolean; data: CreateBookingResponse }>(
      '/api/bookings',
      data
    );
    return response.data.data;
  },

  /**
   * Get user's bookings
   */
  async getMyBookings(): Promise<BookingResponse[]> {
    const response = await apiClient.get<{
      success: boolean;
      data: { bookings: BookingResponse[]; total: number };
    }>('/api/bookings/my');
    return response.data.data.bookings;
  },

  /**
   * Get a single booking by ID
   */
  async getById(id: string): Promise<BookingResponse> {
    const response = await apiClient.get<{ success: boolean; data: BookingResponse }>(
      `/api/bookings/${id}`
    );
    return response.data.data;
  },

  /**
   * Cancel a booking (POST, not PATCH)
   */
  async cancel(id: string, reason?: string): Promise<BookingResponse> {
    const response = await apiClient.post<{ success: boolean; data: BookingResponse }>(
      `/api/bookings/${id}/cancel`,
      { reason }
    );
    return response.data.data;
  },

  /**
   * Reschedule a booking to a new time slot
   */
  async reschedule(id: string, newStartTime: string): Promise<BookingResponse> {
    const response = await apiClient.post<{ success: boolean; data: BookingResponse }>(
      `/api/bookings/${id}/reschedule`,
      { newStartTime }
    );
    return response.data.data;
  },
};
